import React from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Stack,
  Typography,
} from '@mui/material';
import { FilterList as FilterIcon } from '@mui/icons-material';
import { CATEGORIES, Category } from '../db/database';
import { useBudget } from '../context/BudgetContext';

const Filters: React.FC = () => {
  const { filterByCategory, setFilterByCategory, filterByType, setFilterByType } = useBudget();

  return (
    <Box sx={{ 
      p: 2.5, 
      mb: 2,
      bgcolor: 'background.paper', 
      borderRadius: 2,
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
      border: '1px solid',
      borderColor: 'divider',
    }}>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="stretch">
        <Box display="flex" alignItems="center" gap={1.5}>
          <Box sx={{
            bgcolor: 'primary.light',
            borderRadius: '50%',
            p: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <FilterIcon sx={{ color: 'white' }} />
          </Box>
          <Typography variant="subtitle1" fontWeight={600}>
            Filters
          </Typography>
        </Box>

        <FormControl fullWidth size="small" sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: 2,
          }
        }}>
          <InputLabel>Filter by Category</InputLabel>
          <Select
            value={filterByCategory}
            label="Filter by Category"
            onChange={(e) => setFilterByCategory(e.target.value as Category | 'All')}
          >
            <MenuItem value="All">
              <em>All Categories</em>
            </MenuItem>
            {CATEGORIES.map((cat) => (
              <MenuItem key={cat} value={cat}>
                {cat}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth size="small" sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: 2,
          }
        }}>
          <InputLabel>Filter by Type</InputLabel>
          <Select
            value={filterByType}
            label="Filter by Type"
            onChange={(e) => setFilterByType(e.target.value as 'all' | 'income' | 'expense')}
          >
            <MenuItem value="all">
              <em>All Types</em>
            </MenuItem>
            <MenuItem value="income">Income</MenuItem>
            <MenuItem value="expense">Expense</MenuItem>
          </Select>
        </FormControl>
      </Stack>

      {/* Active Filters Display */}
      {(filterByCategory !== 'All' || filterByType !== 'all') && (
        <Box mt={2.5}>
          <Typography variant="caption" color="text.secondary" fontWeight={600} mb={1} display="block">
            Active Filters:
          </Typography>
          <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
            {filterByCategory !== 'All' && (
              <Chip
                label={`Category: ${filterByCategory}`}
                size="small"
                onDelete={() => setFilterByCategory('All')}
                color="primary"
                sx={{ fontWeight: 600 }}
              />
            )}
            {filterByType !== 'all' && (
              <Chip
                label={`Type: ${filterByType}`}
                size="small"
                onDelete={() => setFilterByType('all')}
                color="secondary"
                sx={{ fontWeight: 600 }}
              />
            )}
          </Stack>
        </Box>
      )}
    </Box>
  );
};

export default Filters;
